export const blog = {
  zh: {
    title: "Growin 部落格",
    highlights: "本日精選",
    popular: "熱門文章",
    categories: "文章分類",
    more: "更多文章",
    readMore: "閱讀更多",
    updatedAt: "最後更新日期：",
    author: "作者：",
    summary: "摘要",
    noData: "找不到任何文章",
  },
  en: {
    title: "Growin Blog",
    highlights: "Highlights",
    popular: "Popular Articles",
    categories: "Categories",
    more: "More",
    readMore: "Read More",
    updatedAt: "Last Updated: ",
    author: "Author: ",
    summary: "Summary",
    noData: "No articles found",
  },
};
